import ComptabiliteDashboard from "@features/comptabilite/components/ComptabiliteDashboard";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CalculatorIcon } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/")({
  staticData: {
    title: "Comptabilité",
    icon: CalculatorIcon,
    tab_icon: CalculatorIcon,
    permission: PERMISSIONS.COMPTABILITE.RELANCES.VIEW,
    section: "Comptabilité",
    order: 10,
    description: "Module Comptabilité",
    module: "comptabilite",
    showInTab: false,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: ComptabiliteDashboard,
});
